<template>
  <div class="about">
    <div class="head">
      <p>{{ about }}</p>
    </div>
    <p class="line">仁爱、敬畏、学习</p>
    <p class="text">
      知春资本成立于2017年5月，是一家聚焦于新经济领域的创业投资基金，专注投资下一个十年科技创新、社会结构变化所带来的商业机会。我们聚焦中国企业，致力于寻找到新科技、新消费、新娱乐领域里的卓越公司和优秀创始人，并伴随他们成长。
    </p>
    <p class="text" v-show="hasshow">
      打造对产业未来趋势持续迭代的认知体系，寻找并助力能为世界创造价值的卓越公司，是我们努力的两大核心目标。<br />获得清科、投资界联合发布的“2021年中国早期投资机构30强”；36氪发布的“2021最受创业者欢迎早期投资机构”。
    </p>
    <div class="showbox" v-show="!hasshow" @click="changeshow">
      <div class="moreicon"></div>
      <p>展开查看更多</p>
    </div>
    <div class="btnbox">
      <p class="tip">投递商业计划书</p>
      <div class="btn">
        <p>
          <a href="mailto:bp@atlascap.com.cn">助力创业理想</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      hasshow: false
    };
  },
  computed: {
    ...mapGetters({
      language: "getType"
    }),
    about() {
      return this.language == "中文" ? "关于·知春资本" : "About Atlas";
    },
    desc() {
      return this.language == "中文"
        ? "知春资本成立于2017年5月，是一家聚焦于新经济领域的创业投资基金，专注投资下一个十年科技创新、社会结构变化所带来的商业机会。我们聚焦中国企业，致力于寻找到新科技、新消费、新娱乐领域里的卓越公司和优秀创始人，并伴随他们成长。"
        : "Enabling innovation through computing power and pursuing tech-driven interconnectedness, we focus on fields in social media, entertainment, medical and health industry, and the consumer market.";
    }
  },
  methods: {
    changeshow() {
      this.hasshow = true;
    }
  }
};
</script>

<style lang="less" scoped>
.about {
  width: 100%;
  padding: 0.4rem;
  box-sizing: border-box;

  .text {
    margin-top: 0.22rem;
    font-size: 0.26rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #424242;
    line-height: 0.42rem;
    text-align: justify;
  }
  .line {
    font-size: 0.26rem;
    font-family: PingFang SC;
    font-weight: 300;
    color: #8c8c8c;
    text-align: center;
    margin-top: 0.16rem;
  }
  .head {
    width: 3.24rem;
    border-bottom: 1px solid rgba(51, 51, 51, 0.25);
    margin: 0 auto;
    p {
      font-size: 0.36rem;
      font-weight: 600;
      text-align: center;
      line-height: 0.65rem;
      font-family: PingFang SC;
      color: #333333;
    }
  }
  .aboutbox {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: 0.51rem;
    box-sizing: border-box;
    padding: 0 0.35rem;
    margin-bottom: 0.7rem;
    .item {
      width: 2.05rem;
      height: 3.53rem;
      background-color: rgba(255, 255, 255, 1);
      background-image: url("../../images/niao.png");
      background-size: 1.25rem 1.18rem;
      background-position: center left;
      background-repeat: no-repeat;
      box-shadow: 0.01rem 0.01rem 0.18rem 0 rgba(70, 214, 177, 0.24);
      border-radius: 0.15rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      padding: 0.26rem 0 0.15rem 0;
      position: relative;
      .abouthead {
        width: 100%;
        display: flex;
        align-items: center;
        .icon {
          width: 0.57rem;
          height: 0.54rem;
          background: rgba(109, 221, 176, 1);
          border-top-right-radius: 0.15rem;
          border-bottom-right-radius: 0.15rem;
          p {
            font-size: 0.35rem;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            line-height: 0.54rem;
          }
        }
        .headtext {
          font-size: 0.26rem;
          color: rgba(51, 51, 51, 1);
          margin-left: 0.1rem;
        }
      }
      .box {
        margin: 0.3rem 0.22rem 0;
      }
      .desc {
        font-size: 0.22rem;
        color: rgba(51, 51, 51, 1);
        line-height: 0.5rem;
      }
      .btn {
        cursor: pointer;
        width: 1.66rem;
        height: 0.54rem;
        margin-top: 0.1rem;
        background: url("../../images/btn.png");
        background-size: 100% 100%;
        position: absolute;
        bottom: 0.26rem;
        left: 50%;
        margin-left: -0.83rem;
        p {
          font-size: 0.2rem;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          line-height: 0.57rem;
        }
      }
    }
  }
  .btnbox {
    width: 3.4rem;
    margin: 0.66rem auto 0;
    .tip {
      font-size: 0.25rem;
      color: #333333;
      opacity: 0.61;
      font-size: 0.24rem;
      font-family: PingFang SC;
      font-weight: 500;
      text-align: center;
    }
    a {
      text-decoration: none;
      color: #fff;
    }
    .btn {
      width: 3.4rem;
      height: 0.68rem;
      background: #ff6f00;
      border-radius: 34px;
      margin-top: 0.19rem;
      p {
        font-size: 0.28rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 0.68rem;
      }
    }
  }
  .showbox {
    width: 1.61rem;
    height: 0.25rem;
    font-size: 0.26rem;
    font-family: PingFang SC !important;
    font-weight: 500;
    color: #62c39b;
    margin: 0.5rem auto;
    padding-bottom: 0.4rem;
    .moreicon {
      width: 0.38rem;
      height: 0.29rem;
      margin: 0.15rem auto;
      background: url("../../images/more.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/mycomoponet/about.vue